module.exports = __webpack_public_path__ + "static/img/0544_4.f50426d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0544_4.jpg
// module id = oYir
// module chunks = 1